import { obterProtocolosEntregaAsync } from "../../services/protocoloEntregaService";

const atualizarProtocolosEntrega = async ({ commit }) => {
    const protocolosEntrega = await obterProtocolosEntregaAsync();
    commit('atualizarProtocolosEntrega', protocolosEntrega);
}

const atualizarProtocoloEntrega = ({ commit }, protocoloEntrega) => {
    commit('atualizarProtocoloEntrega', protocoloEntrega);
}

const updateProtocoloEntrega = ({ commit }, protocoloEntrega) => {
    commit('updateProtocoloEntrega', protocoloEntrega);
}

export default {
    atualizarProtocolosEntrega,
    atualizarProtocoloEntrega,
    updateProtocoloEntrega
}